<template>
  <v-container class="pt-0" fuild style="max-width:1280px">
    <v-row>
      <v-col>
        <v-img
            :aspect-ratio="2.6/1"
            src="@/assets/images/sfondo-banner.jpg"
        >
          <v-overlay
              absolute class="d-flex align-center justify-center" color="white" opacity="0.2"
          >
            <v-card class="transparent mb-7 elevation-0">
              <v-container>
                <v-row>
                  <v-col>
                    <h1 v-if="!application.showMobileMenu" class="text-uppercase textmerchant">Il mercato<br> a casa tua
                    </h1>
                    <h1 v-else class="text-uppercase textmerchantmobile text-center">Il mercato a casa tua</h1>
                    <v-layout justify-center>
                      <v-btn outlined tile style="border-width: 3px;margin: 10px auto" class="justify-center"
                             :to="{name:'About'}">CHI SIAMO
                      </v-btn>
                    </v-layout>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-overlay>
        </v-img>
      </v-col>
    </v-row>
    <Cardstransport></Cardstransport>
    <v-row v-if="cassettaMixCatalogProduct !== null">
      <v-col class="mt-3 mx-3 customRaspBerry py-2 px-3">
        <div class="white--text text-uppercase mx-auto banner" style="cursor:pointer" v-on:click="cassettaMixCatalogDialog = true">
          <product-dialog :catalogProduct="cassettaMixCatalogProduct" :dialog="cassettaMixCatalogDialog"
                          @close-dialog="cassettaMixCatalogDialog = false"></product-dialog>
          VUOI UN PIENO DI BONTÀ? CLICCA E ACQUISTA LA NOSTRA CASSETTA MISTA
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="mt-3 mx-3 customRaspBerry py-2 px-3">
        <div class="white--text text-uppercase mx-auto banner">
          ordine dal lunedì alla domenica, ricevi mercoledì sabato e domenica dalle 10 alle 16
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="mt-2 mx-3 customRaspBerry py-2 px-3">
        <div class="white--text text-uppercase mx-auto banner">
          SPEDIZIONE GRATUITA PER ORDINI SOPRA AI 70 EURO DI SPESA
        </div>
      </v-col>
    </v-row>
    <v-spacer style="margin-bottom: 10px"></v-spacer>
    <v-row class="mb-5" id="businesses">
      <v-col cols="12 d-flex">
        <div class="d-flex align-self-end">
          <h1 class="roboto font-weight-thin text-uppercase border-bottom-text mr-3 " style="line-height: 1">
            produttori</h1>
        </div>
        <div style="height:2px;background-color: black" class="d-flex flex-grow-1 align-self-end">
        </div>
        <v-btn @click.stop="viewFilters = !viewFilters"
               icon
               color="black"
               dark
               tile>
          <v-icon>mdi-tune</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-expand-transition>
      <v-row v-show="viewFilters">
        <v-col cols="12" class="pa-0">
          <v-divider class="white"></v-divider>
        </v-col>
        <v-col cols="12" sm="4">
          <v-autocomplete
              outlined
              v-model="filters.aliases"
              :items="selectableBusinessAlias"
              label="Aziende"
              single-line
              hide-details
              dense
              multiple
              clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <v-autocomplete
              outlined
              v-model="filters.provinceIds"
              :items="selectableBusinessProvince"
              label="Provincie"
              single-line
              hide-details
              dense
              multiple
              clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <v-autocomplete
              outlined
              v-model="filters.filterableCategoryIds"
              :items="selectableBusinessFilterableCategories"
              label="Prodotti"
              single-line
              hide-details
              dense
              multiple
              clearable
          ></v-autocomplete>
        </v-col>
      </v-row>
    </v-expand-transition>
    <v-data-iterator
        :items="filteredBusinesses"
        item-key="name"
        :items-per-page="12"
        hide-default-footer
        :loading="getBusinessesRequest.loading"
        :page="pagination.current_page"
    >
      <template v-slot:default="{ items }">
        <v-row>
          <v-col v-for="(business,index) in items" :key="index"
                 class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 px-3 pb-6 d-flex">
            <BusinessCard v-bind:businessData="business"></BusinessCard>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
    <v-row class="mt-3">
      <v-col class="mx-3 text-center middle-black-line" style="position:relative">
        <template v-for="(page,index) in pages">
          <v-btn class="elevation-0 white font-weight-bold"
                 :input-value="pagination.current_page === page"
                 tile
                 text
                 :key="index"
                 small
                 @click="pagination.current_page = page">
            {{ page }}
          </v-btn>
        </template>
      </v-col>
    </v-row>
    <BannerInfo></BannerInfo>

  </v-container>
</template>
<script>
import BusinessCard from "../components/BusinessCard";
import StoreComputed from "@/mixins/StoreComputed";
import responseErrorHandler from "../../../mixins/ResponseErrorHandler";
import Cardstransport from "@/views/ecommerce/components/Cardstransport";
import BannerInfo from "@/views/ecommerce/components/BannerInfo";
import ProductDialog from "@/views/ecommerce/components/product/ProductDialog";

export default {
  name: "Home",
  components: {BusinessCard, Cardstransport, BannerInfo,ProductDialog},
  mixins: [StoreComputed, responseErrorHandler],
  data: () => ({
    businessesIncludes: ['business_type', 'province', 'province.region', 'media'],
    viewFilters: false,
    filters: {aliases: [], provinceIds: [], filterableCategoryIds: []},
    businesses: [],
    showMobileSearch: false,
    isMobile: false,
    pagination: {total: null, last_page: null, current_page: null},
    getBusinessesRequest: {loading: true},
    cassettaMixCatalogProduct: null,
    cassettaMixCatalogDialog: false,
    randomNumber: 1
  }),
  methods: {
    setCassetteMixProducts: function () {
      this.getCassettaMixProducts().then(response => {
        if (response.data.data.length > 0) {
          this.cassettaMixCatalogProduct = response.data.data[0].catalog_product
        }
      }).catch(error => {
        this.handleResponseError(error)
      }).finally(() => {

      })
    },
    setBusinesses() {
      this.getBusinessesRequest.loading = true;
      this.businesses = [];
      this.getBusinesses()
          .then(res => {
            this.businesses = res.data.data.map(business => {
              return business.business;
            });
            this.businesses.sort(function (a, b) {
              return a.alias.localeCompare(b.alias);
            })
            let meta = res.data.meta;
            this.pagination = {total: meta.total, current_page: meta.current_page, last_page: meta.last_page}
          })
          .catch(error => {
            this.handleResponseError(error);
          })
          .finally(() => {
            this.getBusinessesRequest.loading = false;
          });
    },
    getBusinesses: function () {
      return this.axios.get(
          this.config.ecommerce_service_url + '/api/v1/channels/' + this.channel.id + '/businesses',
          {
            params: {
              includes: this.businessesIncludes.join(','),
            },
            headers: {
              Authorization: 'Bearer ' + this.user.jwtToken,
              Accept: 'application/json'
            }
          }
      )
    },
    getCassettaMixProducts: function () {
      return this.axios.get(
          this.config.ecommerce_service_url + '/api/v1/channels/' + this.channel.id + '/products?includes=product.business,product.images,product.certifications,product.specification_sheet,product.stock&product_name:lk=CASSETTA',
          {
            headers: {
              Authorization: 'Bearer ' + this.user.jwtToken,
              Accept: 'application/json'
            }
          }
      )
    }
  },
  mounted() {
    this.setBusinesses();
    this.setCassetteMixProducts();
  },
  watch: {
    filteredBusinesses: function () {
      this.pagination.current_page = 1;
    }
  },
  computed: {
    pages: function () {
      let pages = [];
      for (let i = 1; i <= this.numberOfPages; i++) {
        pages.push(i)
      }
      return pages;
    },
    selectableBusinessAlias: function () {
      return this._.map(this.businesses, (business) => {
        return {text: business.alias, value: business.id};
      });
    },
    selectableBusinessProvince: function () {
      return this._.map(this.businesses, (business) => {
        return {text: business.province.name, value: business.province.id}
      });
    },
    selectableBusinessFilterableCategories: function () {
      let filterableCategories = [];
      this.businesses.forEach(business => {
        business.filterable_categories.forEach(filterableCategory => {
          filterableCategories.push({text: filterableCategory.name, value: filterableCategory.id})
        })
      });
      return this._.uniqBy(filterableCategories, 'value');
    },
    filteredBusinesses: function () {
      let filteredBusinesses = this.businesses;
      let self = this;
      if (self.filters.aliases.length !== 0) {
        filteredBusinesses = this._.filter(filteredBusinesses, function (business) {
          return self.filters.aliases.indexOf(business.id) !== -1;
        });
      }
      if (self.filters.provinceIds.length !== 0) {
        filteredBusinesses = this._.filter(filteredBusinesses, function (business) {
          return self.filters.provinceIds.indexOf(business.province.id) !== -1;
        });
      }
      if (self.filters.filterableCategoryIds.length !== 0) {
        filteredBusinesses = this._.filter(filteredBusinesses, function (business) {
          let businessFilterableCategoriesId = [];
          business.filterable_categories.forEach(filterableCategory => {
            businessFilterableCategoriesId.push(filterableCategory.id)
          });
          return self.filters.filterableCategoryIds.some(r => businessFilterableCategoriesId.indexOf(r) >= 0);
        });
      }
      return filteredBusinesses;
    },
    numberOfPages() {
      return Math.ceil(this.filteredBusinesses.length / 12)
    },
  }
}
</script>
<style>

.frecha {
  margin-top: -10px;
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  background-color: #732342;
  line-height: 0.8;
  font-size: 22px;
}

.textmerchant {
  font-weight: 300;
  font-size: 4em;
  font-family: 'lulofont';
  line-height: 1.1
}

.textmerchantmobile {
  font-weight: 300;
  font-size: 20px;
  font-family: 'lulofont';
  line-height: 1.25
}

.middle-black-line::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  border-top: 2px solid black;
  background: black;
  width: 100%;
  transform: translateY(-50%);
}

.banner {
  font-size: 1.1em !important;
  font-family: 'lulofont' !important;
  text-align: center;
  letter-spacing: -3px !important;
}
</style>
